import React, { useCallback, useEffect, useState, useTransition } from "react";
import classNames from "classnames/bind";
import { DownIcons, Previous } from "../../../components/Icons/Icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Col,
  Row,
  InputTextBox,
  SelectBox,
  SelectBoxItem,
  Toast,
  Loading,
  DateTimePicker,
} from "../../../components";
import useFetchData from "../../../hooks/useFetchData";
import { cameraManagement } from "../../../services/api/cameraManagementApi";
import {
  isValidatorUrl,
  checkValidatorSubmit,
  formatTimeActiveDb,
  formatDDMMYY,
  formatDateToTime,
} from "../../../utils";
import styles from "./AddCamera.module.css";
import { wareHouseAPI } from "../../../services/api/wareHouseAPI";
import { area, lineInternet, typeSetup } from "./config";
import axiosClient from "../../../services/axiosClient";
import { typeCamera } from "../../../services/api/typeCamera";
import FormItem from "./FormItemPass/FormItemPass";

const cx = classNames.bind(styles);
const AddCamera = () => {
  const navigate = useNavigate();
  const [rtsp, setRtsp] = useState();
  const [rtspSup, setRtspSup] = useState();
  const [companyCode, setCompanyCode] = useState();
  const [nameCamera, setNameCamera] = useState();
  const [warehouse, setWareHouse] = useState();
  const [loading, setLoading] = useState(false);
  const [lineInt, setLineInt] = useState();
  const [areaInfo, setArenaInfo] = useState();
  const [activeTime, setActiveTime] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [typeSetting, setTypeSetting] = useState();
  const [listWareHouse, setListWareHouse] = useState([]);
  const [showOtherInfo, setShowOtherInfo] = useState(false);
  const [mainSource, setMainSource] = useState("");
  const [subSource, setSubSource] = useState("");
  const [timeStart, setTimeStart] = useState();
  const [listTypeCamera, setListTypeCamera] = useState([]);
  const [brandCam, setBrandCam] = useState("OTHER");
  const [ipInfoCamera, setIpInfoCamera] = useState({
    camera_ip: "",
    camera_password: "",
    camera_username: "",
  });
  const company = useFetchData("/company/get-list-company/");
  const param = useParams();
  const onChangeRtsp = (data) => {
    setRtsp(data);
  };
  const onChangeNameCamera = (data) => {
    setNameCamera(data);
  };
  const onChangeWareHoues = (data) => {
    setWareHouse(data);
  };
  const onChangeCompany = (data) => {
    setCompanyCode(data);
    setWareHouse();
  };

  const onChangeLineInternet = (data) => {
    setLineInt(data);
  };
  const onChangeTypeSetting = (data) => {
    setTypeSetting(data);
  };
  const onChangeArea = (data) => {
    setArenaInfo(data);
  };
  const onChangeActiveTime = (data) => {
    // 2023/07/18 07:07:07
    let time = formatTimeActiveDb(data.target.value);
    setActiveTime(time);
  };
  const onChangeRtspSup = (data) => {
    setRtspSup(data);
  };
  const onChangeBrandCam = (data) => {
    setBrandCam(data);
  };
  useEffect(() => {
    const getListTypeCam = async () => {
      try {
        const types = await typeCamera.get();
        if (types && types?.data) {
          const listTypeCam = types?.data?.map((item) => {
            return {
              CODE: item?.CODE,
              NAME: item?.SUBJECT_NAME,
            };
          });
          setListTypeCamera(listTypeCam);
        }
      } catch (error) {
        // // console.log(error);
      }
    };
    getListTypeCam();
  }, []);

  const startStreaming = async (code, quality) => {
    const qlt = quality.slice(0, -1);
    const infoCamera = JSON.stringify({
      camera_id: code,
      fps_stream: "10",
      fps_record: "10",
      quality_record: Number(qlt) <= 480 ? quality : "480p",
      quality_stream: Number(qlt) <= 480 ? quality : "480p",
    });
    await cameraManagement.startStreaming(
      "streamManagement/post-start-streaming/",
      infoCamera
    );
  };

  const upDateStatusCamera = async (code) => {
    await cameraManagement.update({ camera_status: "On" }, code);
  };

  const handleCheckCameraIp = async () => {
    if (brandCam !== "OTHER") {
      try {
        const infoCheck = {
          ...ipInfoCamera,
          camera_ip: ipInfoCamera.camera_ip.split("://")[1],
        };
        const check = await typeCamera.post(infoCheck);
        return check?.result ? check?.result : false;
      } catch (error) {
        return false;
      }
    } else {
      return true;
    }
  };
  const handleAddCamera = async () => {
    setLoading(true);
    setIsSubmit(true);
    try {
      let info = [warehouse, nameCamera, companyCode];
      const checkRtspSup = rtspSup ? isValidatorUrl(rtspSup) : true;
      if (
        checkValidatorSubmit(isValidatorUrl(rtsp), info) &&
        checkRtspSup &&
        handleCheckCameraIp()
      ) {
        const data = {
          rtsp_chinh: rtsp,
          rtsp_phu: rtspSup,
          company_code: companyCode,
          prioritized: 1,
          camera_name: nameCamera,
          warehouse_code: warehouse,
          active_time: activeTime,
          // area: areaInfo,
          // internet: lineInt,
          // type_setup: typeSetting,
          camera_type_code: brandCam,
          ...ipInfoCamera,
          camera_ip: ipInfoCamera.camera_ip,
        };
        const res = await cameraManagement.add(
          "/cameraManagement/post-add-camera/",
          data
        );
        // bat camera
        startStreaming(res.camera_code, res.main_source);
        // up date on
        upDateStatusCamera(res.camera_code);
        setLoading(false);
        Toast.open("Thêm mới camera thành công", "success");
        navigate(-1, { replace: true });
        return res;
      }

      if (checkValidatorSubmit(isValidatorUrl(rtsp), info) && checkRtspSup) {

        Toast.open(
          `Thông tin camera ${listTypeCamera.find((it) => it.CODE === brandCam)?.NAME
            ? listTypeCamera.find((it) => it.CODE === brandCam)?.NAME
            : "camera"
          } không hợp lệ!`,
          "danger"
        );
        setLoading(false);
      } else {
        setLoading(false);
        info.forEach((item, index) => {
          // // console.log(item);
          if (item === undefined && index === 0) {

            setWareHouse("");
          } else if (item === undefined && index === 1) {
            setNameCamera("");
          }
        });

        Toast.open(
          "Vui lòng nhập hết các trường bắt buộc có dấu (*)",
          "danger"
        );
      }
    } catch (e) {
      setLoading(false);
      if (e.response?.status === 403) {
        Toast.open("Bạn không có quyền thêm camera", "danger");
      }
      if (e.response.status === 500) {
        Toast.open("Lỗi từ phía server", "danger");
      } else {
        Toast.open(e.response?.data?.result, "danger");
      }
    }
  };

  const getListWareHouse = useCallback(async (codeCom) => {
    try {
      let params = {
        company_code: codeCom,
      };
      const res = await wareHouseAPI.getWareHouseForAddCamera(params);
      setListWareHouse(res);
    } catch (error) {
      console.error("We can't get list warehouse with this company code");
    }
  }, []);
  useEffect(() => {
    if (companyCode) {
      getListWareHouse(companyCode);
    }
  }, [getListWareHouse, companyCode]);

  const handleShowOtherInfo = () => {
    setShowOtherInfo(!showOtherInfo);
  };
  const [oldRtsp, setOldRtsp] = useState("");
  useEffect(() => {
    const getCameraInfo = async (code) => {
      try {
        const params = {
          camera_code: code,
        };
        const res = await cameraManagement.getOne(params);
        const data = res[0];
        setNameCamera(data?.NAME_CAM);
        setRtsp(data?.RTSP_CHINH);
        setRtspSup(data?.RTSP_PHU);
        setCompanyCode(data?.COMPANY_CODE);
        setWareHouse(data?.WAREHOUSE_CODE);
        setMainSource(
          `${data?.STREAM_MODE}-${data?.MAIN_SOURCE}-${data?.WIDTH}x${data?.HEIGHT}-${data.ASPECT_RATIO}`
        );
        setSubSource(
          data?.SUB_SOURCE
            ? `${data?.STREAM_MODE}-${data?.SUB_SOURCE}-${data?.WIDTH_PHU}x${data?.HEIGHT_PHU}-${data.ASPECT_RATIO_PHU}`
            : ""
        );
        setTimeStart(data?.START_USE_TIME);
        setArenaInfo(data?.AREA);
        setTypeSetting(data?.TYPE_SETUP);
        setLineInt(data?.INTERNET);
        setActiveTime(data?.ACTIVE_TIME);
        setOldRtsp(data?.RTSP_CHINH);
        setIpInfoCamera((info) => ({ ...info, camera_ip: data?.CAMERA_IP }));
        // // console.log(data?.CAMERA_IP);
        const branch = data?.CAMERA_TYPE_CODE
          ? data?.CAMERA_TYPE_CODE
          : "OTHER";
        setBrandCam(branch);
      } catch (error) {
        Toast.open("Bạn không có quyền quản trị camera", "danger");
      }
    };
    if (param.id) {
      getCameraInfo(param.id);
    }
  }, [param.id]);
  const handleChangeInfoCam = async () => {
    setLoading(true);
    try {
      let info = [warehouse, nameCamera, companyCode];
      const checkSupRtsp = rtspSup ? isValidatorUrl(rtspSup) : true;
      if (checkValidatorSubmit(isValidatorUrl(rtsp), info) && checkSupRtsp && handleCheckCameraIp()) {
        const data = {
          rtsp_chinh: rtsp,
          rtsp_phu: rtspSup,
          company_code: companyCode,
          prioritized: 1,
          camera_name: nameCamera,
          warehouse_code: warehouse,
          active_time: activeTime,
          area: areaInfo,
          width:
            mainSource.split("-").length >= 2
              ? mainSource.split("-")[2]?.split("x")[0]
              : 2688,
          width_phu:
            subSource.split("-").length >= 2
              ? subSource.split("-")[2]?.split("x")[0]
              : 2688,
          aspect_ratio:
            mainSource.split("-").length >= 2
              ? mainSource.split("-")[3]
              : "16/9",
          aspect_ratio_phu:
            subSource.split("-").length >= 2 ? subSource.split("-")[3] : "16/9",
          height:
            mainSource.split("-").length >= 2
              ? mainSource.split("-")[2]?.split("x")[1]
              : 1520,
          height_phu:
            subSource.split("-").length >= 2
              ? subSource.split("-")[2]?.split("x")[1]
              : 1520,
          // internet: lineInt,
          // type_setup: typeSetting,
          camera_type_code: brandCam,
          // camera_type_code: brandCam,
          ...ipInfoCamera,
          camera_ip: ipInfoCamera.camera_ip,
        };
        const res = await cameraManagement.update(data, param.id);
        if (rtsp !== oldRtsp) {
          await cameraManagement.restartStream({
            camera_id: param.id,
          });
        }
        Toast.open("Sửa thông tin camera thành công", "success");
        setLoading(false);
        navigate(-1, { replace: true });
        return res;
      }
      if (
        !handleAddCamera() &&
        checkValidatorSubmit(isValidatorUrl(rtsp), info) &&
        checkSupRtsp
      ) {
        Toast.open(
          `Thông tin camera ${listTypeCamera.find((it) => it.CODE === brandCam)?.NAME
            ? listTypeCamera.find((it) => it.CODE === brandCam)?.NAME
            : ""
          } không hợp lệ!`,
          "danger"
        );
        setLoading(false);
      } else {
        setLoading(false);
        Toast.open("Sửa thông tin camera không thành công", "danger");
      }
    } catch (error) {
      setLoading(false);
      // // console.log(error);
      if (error.response.status === 403) {
        Toast.open("Bạn không có quyền sửa thông tin camera ", "danger");
      }
      if (error.response.status === 500) {
        Toast.open("Lỗi từ phía server", "danger");
      } else {
        Toast.open(
          error?.response?.data?.result
            ? error?.response?.data?.result
            : "Sửa thông tin camera không thành công",
          "danger"
        );
      }
    }
  };

  const handleSubmit = () => {
    if (param.id) {
      handleChangeInfoCam();
    } else {
      handleAddCamera();
    }
  };
  const handleBack = () => {
    navigate(-1, { replace: true });
  };

  const handleChangeIpInfo = (value, key) => {
    setIpInfoCamera((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  return (
    <div>
      <div className={cx("header")}>
        <button style={{ textDecoration: "none" }} onClick={handleBack}>
          <span className={cx("icon")}>
            <Previous />
          </span>
        </button>
        <h1 className={cx("title")}>
          {param.id ? "Chỉnh sửa thông tin camera" : "Thêm mới camera"}
        </h1>
      </div>
      <div className={cx("content")}>
        <div className={cx("block-info")}>
          <div className={cx("block-info_label")}>
            <h1 className={cx("block-info_label-content")}>
              Thông tin cơ bản *
            </h1>
          </div>
          <Row gap={[0, 16]}>
            <Col style={{ marginTop: 2 }} span={6}>
              <InputTextBox
                submit={isSubmit}
                style={{ marginBottom: 12 }}
                type="text"
                placeholder="Nhập"
                title="Tên camera *"
                onChange={onChangeNameCamera}
                value={nameCamera}
                error={nameCamera ? false : true}
                titleError="Vui lòng nhập tên camera"
              />
              <SelectBox
                isSubmit={isSubmit}
                style={{ marginBottom: 12 }}
                type="small"
                required
                title="Kho *"
                select
                onChange={onChangeWareHoues}
                values={
                  listWareHouse?.find(
                    (item) => item?.WAREHOUSE_CODE === warehouse
                  )?.WAREHOUSE_NAME
                }
              >
                {listWareHouse.length > 0 ? (
                  listWareHouse?.map((item, index) => (
                    <SelectBoxItem
                      label={item.WAREHOUSE_NAME}
                      value={item.WAREHOUSE_CODE}
                      key={index}
                    />
                  ))
                ) : (
                  <span></span>
                )}
              </SelectBox>
              <div style={{ flex: 1 }}>
                <DateTimePicker
                  onChange={onChangeActiveTime}
                  value={activeTime}
                  title={"Thời gian kích hoạt"}
                  styles={{ marginBottom: 10, marginTop: 0 }}
                />
              </div>
              <InputTextBox
                submit={isSubmit}
                style={{ marginBottom: 12 }}
                type="text"
                placeholder="Nhập"
                title="Đường dẫn rtsp chính*"
                onChange={onChangeRtsp}
                value={rtsp}
                error={isValidatorUrl(rtsp) ? false : true}
                titleError="Vui lòng nhập đúng đường dẫn rtsp"
              />
              <InputTextBox
                type="text"
                placeholder="Nhập"
                title="Đường dẫn rtsp phụ "
                onChange={onChangeRtspSup}
                value={rtspSup}
                error={isValidatorUrl(rtspSup) ? false : true}
                titleError="Vui lòng nhập đúng đường dẫn rtsp"
                style={{ marginBottom: 12 }}
              />

              {brandCam !== "OTHER" && (
                <>
                  <div className={cx('ip_address')}>
                    <InputTextBox
                      style={{ marginBottom: 12 }}
                      type="text"
                      placeholder="Nhập"
                      title="Địa chỉ ip *"
                      onChange={(data) => handleChangeIpInfo(data, "camera_ip")}
                      value={ipInfoCamera.camera_ip}
                      error={
                        ipInfoCamera.camera_ip?.trim().length > 0 ? false : true
                      }
                      titleError="Địa chỉ IP không được để trống"
                      name={"ip"}
                    />
                    <label className={cx("label", "note")}>
                      (Lưu ý: địa chỉ ip là port web có dạng
                      "http://ip:port")
                    </label>
                  </div>
                  {!param.id && (
                    <div>
                      <label className={cx("label")}>Mật khẩu*</label>
                      <FormItem
                        label={""}
                        name={"ipPass"}
                        values={ipInfoCamera.camera_password}
                        onChange={(data) =>
                          handleChangeIpInfo(data, "camera_password")
                        }
                        type={"password"}
                        warning={""}
                        typeVl={"other"}
                        rules={[
                          {
                            isRequire: true,
                            mess: "Mật khẩu không được để trống",
                          },
                        ]}
                        style={{ flex: 1, marginTop: "8px" }}
                      />
                    </div>
                  )}

                </>
              )}
            </Col>
            <Col span={6}>
              <SelectBox
                isSubmit={isSubmit}
                type="small"
                required
                title="Công ty *"
                select
                style={{ marginBottom: 12 }}
                onChange={onChangeCompany}
                values={
                  company?.data?.data.find((item) => item?.CODE === companyCode)?.NAME
                }
              >
                {company?.data?.data &&
                  company?.data?.data.map((item, index) => (
                    <SelectBoxItem
                      label={item.NAME}
                      value={item.CODE}
                      key={index}
                    />
                  ))}
              </SelectBox>

              <SelectBox
                isSubmit={isSubmit}
                style={{ marginBottom: 13 }}
                type="small"
                required
                title="Hãng cam"
                select
                onChange={onChangeBrandCam}
                values={
                  listTypeCamera.find((it) => it?.CODE === brandCam)?.NAME
                    ? listTypeCamera.find((it) => it?.CODE === brandCam)?.NAME
                    : "Khác"
                }
              // disabled={!param.id}
              >
                {listTypeCamera.length > 0 ? (
                  listTypeCamera?.map((item, index) => (
                    <SelectBoxItem
                      label={item.NAME}
                      value={item.CODE}
                      key={index}
                    />
                  ))
                ) : (
                  <span></span>
                )}
              </SelectBox>
              <InputTextBox
                style={{ marginBottom: 12 }}
                type="text"
                placeholder="Nhập"
                title="Thời gian bắt đầu sử dụng"
                disabled
                value={timeStart ? formatDDMMYY(timeStart) : ""}
              />

              <InputTextBox
                style={{ marginBottom: 12 }}
                type="text"
                placeholder="Nhập"
                title="Độ phân giải nguồn chính"
                value={mainSource}
                onChange={(data) => setMainSource(data)}
                disabled={param.id ? false : true}
              />
              <InputTextBox
                style={{ marginBottom: 12 }}
                type="text"
                placeholder="Nhập"
                title="Độ phân giải nguồn phụ"
                value={`${subSource}`}
                disabled={param.id ? false : true}
                onChange={(data) => setSubSource(data)}
              />
              {brandCam !== "OTHER" && (
                <InputTextBox
                  style={{ marginBottom: 12 }}
                  type="text"
                  placeholder="Nhập"
                  title="Tên đăng nhập*"
                  onChange={(data) =>
                    handleChangeIpInfo(data, "camera_username")
                  }
                  value={ipInfoCamera.camera_username}
                  error={
                    ipInfoCamera.camera_username.trim().length > 0
                      ? false
                      : true
                  }
                  titleError="Tên đăng nhập không được để trống"
                />
              )}
            </Col>
          </Row>
        </div>

        <Row gap={[0, 16]}>
          <Col span={6}>
            {/* <SelectBox
                  style={{ marginBottom: 12, marginTop: -2 }}
                  type="small"
                  title="Đường truyền internet *"
                  select
                  onChange={onChangeLineInternet}
                  values={lineInt}
                >
                  {lineInternet.map((item, index) => (
                    <SelectBoxItem
                      label={item.label}
                      value={item.value}
                      key={index}
                    />
                  ))}
                </SelectBox> */}
          </Col>
          <Col span={6}>
            {/* <SelectBox
                  style={{ marginBottom: 12,marginTop: -2  }}
                  type="small"
                  title="Hình thức lắp đặt *"
                  select
                  onChange={onChangeTypeSetting}
                  values={typeSetting}
                >
                  {typeSetup.map((item, index) => (
                    <SelectBoxItem
                      label={item.label}
                      value={item.value}
                      key={index}
                    />
                  ))}
                </SelectBox> */}

            {/* <SelectBox
                  style={{ marginTop: -2 }}
                  type="small"
                  title="Khu vực *"
                  select
                  onChange={onChangeArea}
                  values={areaInfo}
                >
                  {area.map((item, index) => (
                    <SelectBoxItem
                      label={item.label}
                      value={item.value}
                      key={index}
                    />
                  ))}
                </SelectBox> */}
          </Col>
        </Row>

        <Row gap={[12, 12]}>
          <button onClick={handleSubmit} className={cx("btn-add")}>
            Lưu cài đặt
          </button>
          <Link style={{ textDecoration: "none" }} to="/admin/camera">
            <button className={cx("btn-cancel")}>Hủy bỏ</button>
          </Link>
        </Row>
      </div>
      {loading && (
        <div className={cx("loading-modal")}>
          <Loading />
        </div>
      )}
    </div>
  );
};
export default AddCamera;
